<template lang='pug'>
canvas(ref="canvas")
</template>

<script>
import Flow from "./Flow";
import Hammer from "hammerjs";

const getOffset = (element) => {
  let top = 0;
  let left = 0;
  while (element) {
    top += +element.offsetTop;
    left += +element.offsetLeft;
    element = element.offsetParent;
  }
  return [top, left];
};

export default {
  props: {
    inkDiffusion: {
      type: Number,
      default: 1,
    },
    colorOnPan: {
      type: Boolean,
      default: false,
    },
    displayField: {
      type: Boolean,
      default: true,
    },
    updateField: {
      type: Boolean,
      default: true,
    },
    updateInk: {
      type: Boolean,
      default: true,
    },
    speed: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    displayField() {
      if (this.flow) this.flow.displayField = this.displayField;
    },
    updateField() {
      if (this.flow) this.flow.updateField = this.updateField;
    },
    updateInk() {
      if (this.flow) this.flow.updateInk = this.updateInk;
    },
    updateInk() {
      if (this.flow) this.flow.updateInk = this.updateInk;
    },
    speed() {
      if (this.flow) this.flow.speed = this.speed;
    },
  },
  mounted() {
    const flow = new Flow(this.$refs.canvas);
    window.flow = this.flow = flow;
    flow.start();

    const hammer = new Hammer(this.$refs.canvas);
    hammer.get("pan").set({ direction: Hammer.DIRECTION_ALL });
    hammer.get("swipe").set({ direction: Hammer.DIRECTION_ALL });
    hammer.on("pan", (event) => {
      if (
        this.colorOnPan &&
        (flow.inkSources.length == 0 ||
          flow.inkSources[flow.inkSources.length - 1].count > 2)
      ) {
        const [offsetTop, offsetLeft] = getOffset(this.$refs.canvas);
        flow.inkSources.push({
          center: {
            x: (event.center.x - offsetLeft) / flow.canvas.width,
            y: 1 - (event.center.y - offsetTop) / flow.canvas.height,
          },
          size: 0.05,
          start: 0,
          count: 0,
        });
      }
    });
    hammer.on("swipe", (event) => {
      const [vx, vy] = [event.overallVelocityX, event.overallVelocityY];
      const forceScale = 3 / Math.hypot(vx, vy);
      if (Math.abs(event.overallVelocity) > 0.1) {
        const [offsetTop, offsetLeft] = getOffset(this.$refs.canvas);
        flow.forces.push({
          center: {
            x: (event.center.x - event.deltaX - offsetLeft) / flow.canvas.width,
            y:
              1 -
              (event.center.y - event.deltaY - offsetTop) / flow.canvas.height,
          },
          radius: 0.02,
          force: {
            x: vx * forceScale,
            y: -vy * forceScale,
          },
          time: 1,
        });
      }
    });

    flow.addEventListener("beforeTick", (event) => {
      flow.displayField = this.displayField;
      flow.updateInk = this.updateInk;
      flow.updateField = this.updateField;
      flow.speed = this.speed;
      flow.inkDiffusion = 0.00001 * this.inkDiffusion;

      const dt = event.detail.dt;
      const time = event.detail.time;
      flow.inkSources = flow.inkSources
        .map((s) => {
          if (s.start == 0) s.start = time;
          ++s.count;
          return s;
        })
        .filter((s) => s.start + 1000 > time);
      flow.forces = flow.forces
        .map((f) => {
          const scale = 1;
          return {
            center: f.center,
            radius: f.radius,
            force: { x: scale * f.force.x, y: scale * f.force.y },
            time: f.time - dt,
          };
        })
        .filter((f) => f.time > 0);
    });
  },
  destroyed() {
    this.flow.stop();
  },
};
</script>
